import { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { AiOutlineArrowRight } from "components/atoms/Icon/ai/AiOutlineArrowRight";
import { FaChevronLeft } from "components/atoms/Icon/fa/FaChevronLeft";
import { FaChevronRight } from "components/atoms/Icon/fa/FaChevronRight";
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import PostItem from "components/molecules/PostItem";

const Component = ({ id, category, posts }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const swiper = {
    preloadImages: false,
    lazy: true,
    pagination: {
      el: ".bbc-slide-pagination",
      clickable: true,
      bulletActiveClass: "!bg-bbc-brand-500 !opacity-100",
    },
    navigation: {
      nextEl: `.bbc-button-next-${id}`,
      prevEl: `.bbc-button-prev-${id}`,
      disabledClass: "lg:hidden",
    },
    slidesPerView: 3,
    spaceBetween: 30,
    // Responsive breakpoints
    breakpoints: {
      1280: {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 1,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 30,
      },

      768: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 40,
        navigation: true,
      },
    },
  };

  useEffect(() => {
    const currentSwiper = document.querySelector(`.swiper-${id}`);

    if (currentSwiper) {
      setCurrentIndex(currentSwiper.swiper.activeIndex);
    }
  }, [currentIndex]);

  return (
    <>
      {posts.length > 0 && (
        <div className={`${id === 0 ? "" : "mt-10 lg:mt-20"}`}>
          <div className="container mb-6 flex items-center justify-between lg:items-end">
            <Title
              text={category.name}
              className="text-2xl font-semibold leading-9 lg:text-bbc-30px"
            />
            <Link href={category.uri} className="flex text-bbc-brand-600">
              See more
              <AiOutlineArrowRight size={24} className="ml-2" />
            </Link>
          </div>
          <div className={"overflow-hidden"}>
            <div className="container relative">
              <Swiper
                modules={[Autoplay, Navigation, Pagination]}
                className={`swiper-${id} !overflow-visible`}
                {...swiper}
                onSlideChange={(swiperCore) => {
                  const { activeIndex } = swiperCore;

                  setCurrentIndex(activeIndex);
                }}
              >
                {posts.map((item, index) => (
                  <SwiperSlide
                    className={`col-3 !h-auto ${
                      index === currentIndex
                        ? "opacity-100"
                        : index === currentIndex + 1
                        ? "opacity-20 lg:opacity-100"
                        : index === currentIndex + 2
                        ? "opacity-20 xl:opacity-100"
                        : "opacity-20"
                    }`}
                    key={index}
                  >
                    <div className="h-full">
                      <PostItem post={item} />
                    </div>
                  </SwiperSlide>
                ))}
                <div
                  className={
                    "bbc-slide-pagination relative  block pt-6 text-center lg:invisible"
                  }
                ></div>
              </Swiper>
              <div
                className={`bbc-button-prev-${id} absolute top-1/2 left-0 z-10 hidden h-12 w-12 -translate-y-1/2 -translate-x-1/2 cursor-pointer items-center justify-center rounded-full bg-bbc-brand-600 transition-all duration-150 ease-in-out hover:opacity-60 lg:flex`}
              >
                <FaChevronLeft size={16} className="text-white" />
              </div>
              <div
                className={`bbc-button-next-${id} absolute top-1/2 right-0 z-10 hidden h-12 w-12 -translate-y-1/2 translate-x-1/2 cursor-pointer items-center justify-center rounded-full bg-bbc-brand-600 transition-all duration-150 ease-in-out hover:opacity-60 lg:flex`}
              >
                <FaChevronRight size={16} className="text-white" />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Component;

Component.propTypes = {
  id: PropTypes.number,
  posts: PropTypes.array,
  category: PropTypes.object,
};

Component.defaultProps = {
  id: 0,
  posts: [],
  category: {},
};
